// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"267":"css/online_booking/styles","671":"css/system/easypractice","696":"css/waiting_list/styles","792":"css/system/practize"}[chunkId] + ".css";
};